import {
	Academia,
	Antibodies,
	Biomanufacturers,
	Biopharma,
	Biopharmaceutical,
	BiopharmaIcon,
	Biorepositories,
	CellTherapy,
	Chemistry,
	ClinicalResearch,
	ContractServices,
	CRO,
	IndustrialBiotech,
	RNA,
	Startups,
} from "@assets/icons";
import React from "react";
import ColumnsTemplate from "./ColumnsTemplate";
import { NavbarTopic } from "./Products";

export const links: NavbarTopic[] = [
	{
		id: 1,
		title: "Industries",
		topics: [
			{
				id: 1,
				title: "Biopharmaceutical",
				icon: <Biopharmaceutical />,
				to: "BIOPHARMACEUTICAL",
			},
			{
				id: 2,
        to: "BIOTECH",
				title: "Industrial biotech",
				icon: <IndustrialBiotech />,
			},
			{
				id: 3,
        to: "RESEARCH",
				title: "Clinical research",
				icon: <ClinicalResearch />,
			},
			{
				id: 4,
        to: "MANUFACTURING",
				title: "Biomanufacturers",
				icon: <Biomanufacturers />,
			},
			{
				id: 5,
        to: "REPOSITORY",
				title: "Biorepositories",
				icon: <Biorepositories />,
			},
			{
				id: 6,
        to: "SERVICES",
				title: "Contract services",
				icon: <ContractServices />,
			},
		],
	},
	{
		id: 2,
		title: "Research",
		topics: [
			{
				id: 1,
        to: "CELL_THERAPY",
				title: "Cell therapy",
				icon: <CellTherapy />,
			},
			{
				id: 2,
        to: "RNA_THERAPY",
				title: "RNA therapy",
				icon: <RNA />,
			},
			{
				id: 3,
        to: "ANTIBODIES",
				title: "Antibodies",
				icon: <Antibodies />,
      },
			{
				id: 4,
        to: "CRO_CONSULTING",
				title: "CRO/Consulting",
				icon: <CRO />,
			},
			{
				id: 5,
        to: "CHEMISTRY",
				title: "Chemistry",
				icon: <Chemistry />,
			},
		],
	},
	{
		id: 3,
		title: "Genemod for",
		topics: [
			{
				id: 1,
				title: "Biopharma",
				icon: <BiopharmaIcon />,
				to: "BIOPHARMA",
			},
			{
				id: 2,
				title: "Startups",
				icon: <Startups />,
				to: "STARTUPS",
			},
			{
				id: 3,
				title: "Academia",
				icon: <Academia />,
				to: "ACADEMIA",
			},
			
		],
	},
];

const Solutions = () => {
	return <ColumnsTemplate columns={links} />;
};

export default Solutions;
